<template>
  <div class="idea-access-chooser">
    <div class="py-1 mb-2">
      <div>
        <p class="idea-access-chooser-title mt-0 mb-2 font-outfit-regular">
          {{ $t('pages.users.chooseIdeasYouWantThemJoin') }}
        </p>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <el-checkbox
          :value="isCheckedAll"
          :indeterminate="isIndeterminate"
          @change="toggleSelectAll"
        >
          {{ $t('selectAll') }}
        </el-checkbox>
        <div class="guest-buddy-wrapper d-flex align-items-center">
          <ib-tooltip
            popper-class="plan-popper"
            :content="$t('pages.users.inviteGuestDescription')"
          >
            <p>{{ $t('userRoles.guest') }}</p>
          </ib-tooltip>
          <ib-tooltip
            popper-class="plan-popper"
            :content="$t('pages.users.inviteBuddyDescription')"
          >
            <p>{{ $t('userRoles.buddy') }}</p>
          </ib-tooltip>
        </div>
      </div>
    </div>

    <div
      class="scrollable-wrapper py-1 pr-2"
      :class="{'more': ideas.length > 6}"
    >
      <el-row
        v-for="idea in ideas"
        :key="idea.id"
        class="mb-3 mb-sm-1"
      >
        <el-col :sm="14" class="mb-1 mb-sm-0">
          <el-checkbox
            v-model="idea.enable"
            @change="toggleEnableDisable($event, idea)"
          >
            {{ idea.name }}
          </el-checkbox>
        </el-col>
        <el-col :sm="10" class="d-flex justify-content-around">
          <el-radio-group
            v-model="idea.role"
            :disabled="!idea.enable"
          >
            <el-radio
              v-for="role in options"
              :key="role.value"
              :label="role.value"
            >
              {{ role.title }}
            </el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
    </div>
    <div v-if="error" class="error-msg-wrapper mt-1">
      <p class="m-0 position-absolute text-danger">
        {{ error }}
      </p>
    </div>
  </div>
</template>

<script>
import UserRoleEnum from '@/constants/UserRoleEnum'

export default {
  name: 'IdeaAccessChooser',

  props: {
    value: {
      type: Array,
      required: true
    },

    error: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      UserRoleEnum,
      options: [
        {
          title: this.$t('userRoles.guest'),
          value: UserRoleEnum.GUEST
        },
        {
          title: this.$t('userRoles.buddy'),
          value: UserRoleEnum.BUDDY
        }
      ]
    }
  },

  computed: {
    ideas: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },

    countEnabledIdeas () {
      return this.ideas.filter(idea => idea.enable).length
    },

    isCheckedAll () {
      return this.countEnabledIdeas === this.ideas.length
    },

    isIndeterminate () {
      return !!(this.countEnabledIdeas && this.countEnabledIdeas < this.ideas.length)
    }
  },

  methods: {
    toggleEnableDisable (val, idea) {
      const index = this.findIdeaIndex(idea)
      this.ideas[index].enable = val
    },

    toggleSelectAll (val) {
      this.ideas.forEach(idea => {
        idea.enable = val
      })
    },

    findIdeaIndex (idea) {
      const found = this.ideas.find(item => item.id === idea.id)

      return this.ideas.indexOf(found)
    }
  }
}
</script>

<style scoped lang="scss">
.idea-access-chooser {
  .idea-access-chooser-title {
    font-size: 18px;
    color: $color-font;
  }

  .guest-buddy-wrapper {
    font-size: 14px;
    column-gap: 15px;

    p {
      cursor: pointer;
      border-bottom: 2px dotted #51597A;
      padding-bottom: 1px;
    }
  }

  .scrollable-wrapper {
    overflow: hidden auto;
    max-height: 112px;

    &.more {
      max-height: 115px;

      @include media-breakpoint-up($sm) {
        max-height: 172px;
      }
    }
  }

  .error-msg-wrapper {
    p {
      font-size: 13px;
    }
  }
}
</style>
